const CURRENCY_SYM = window.SelkirkStore?.currencySymbol || '$';

document.addEventListener('DOMContentLoaded', function() {
    Cart.init();
});

const Cart = {
    selectors: {
        "htmlEl": { selector: "html", type: "single", scope: "document" },
        "cartIcon": { selector: ".header-cart .cart-icon", type: "single", scope: "document" },
        "cartClose": { selector: ".close-cart", type: "single", scope: "document" },
        "wrapperOverlay": { selector: ".wrapper-overlay", type: "single", scope: "document" },
        "removeItemBtns": { selector: '.mini-products-list .btn-remove, .cart-list .btn-remove', type: 'all', scope: 'document'},
        "noItems": { selector: ".no-items", type: "single", scope: "document" },
        "hasItems": { selector: ".has-items", type: "single", scope: "document" },
        "loadingSpinner": { selector: ".icon-loading", type: "single", scope: "document" },
        "cartTemplate": { selector: ".cart-template", type: "single", scope: "document" },
        "quantityInputs": { selector: ".item-quantity", type: "all", scope: "document"},
        "addGiftBtns": { selector: ".gift-product-card button", type: "all", scope: "document" },
        "quickAddBtns": { selector: ".quick-add-to-cart", type: "all", scope: "document" },
        "hasAnyTiersBars": { selector: ".progress-bar-tiers", type: "all", scope: "document" },
        "multiplierProgressBar": { selector: ".progress-bar-multiplier", type: "single", scope: "document" },
        "progressFreeShippingBar": { selector: ".free_shipping_progress", type: "single", scope: "document" },
        "dropdownCart": { selector: "#dropdown-cart", type: "single", scope: "document" },
        "fullPageShippingEl": { selector: ".price.shipping-price", type: "single", scope: "document" },
        "sideBarShippingEl":  { selector: ".price-text.shipping-text", type: "single", scope: "document" },
        "popupChatCartConfirmShippingEl": { selector: "[data-cart-confirm-shipping]", type: "single", scope: "document" },
        "upsellContainers": { selector: ".upsell-promo-container", type: "all", scope: "document" },
        "defaultContainer": { selector: ".customers-also-bought", type: "single", scope: "document" },
        "customBannerLink": { selector: ".custom-banner-link", type: "single", scope: "document" }
    },
  
    init: async function() { 
        Utility.fetchEls(this.selectors, this);
        this.initEventListeners();
        this.promo = '';
        this.promoAmount = .5;
        this.parent;
        this.threshold;
        this.UPCHARGE_VARIANT_ID = '43392971997286'; // variant id for paddle customizations $5 upcharge


        if (this.cartTemplate) {
          this.parent = this.cartTemplate;
        } else {
          this.parent = this.dropdownCart;
        }
        
        // Bundle cart sidebar sync
        const initialCartData = await this.getCartItems();
        if (initialCartData && Array.isArray(initialCartData.items)) {
            const hasBundleLines = initialCartData.items.some((item) => {
                return this.getLineProperty(item, '_bundle_token');
            });
            if (hasBundleLines) {
                await this.updateCart();
            }
        }
    },

    // Helper function to get a line item property
    getLineProperty: function (item, propertyName) {
        if (!item || !item.properties) {
            return null;
        }

        if (Array.isArray(item.properties)) {
            const match = item.properties.find((entry) => {
                return entry.name === propertyName || entry[0] === propertyName;
            });
            if (match) {
                const value = match.value || match[1];
                if (value !== undefined && value !== null && String(value).trim() !== '') {
                    return String(value).trim();
                }
            }
            return null;
        }

        const value = item.properties[propertyName];
        if (value !== undefined && value !== null && String(value).trim() !== '') {
            return String(value).trim();
        }

        return null;
    },

    // Helper function to sync sidebar line items
    syncSidebarLineItems: async function (cartData) {
        if (!cartData || !Array.isArray(cartData.items)) {
            return;
        }

        const list = document.querySelector('.mini-products-list');
        if (!list) {
            return;
        }

        const analysis = this.analyzeBundleLines(cartData.items);

        for (let index = 0; index < cartData.items.length; index += 1) {
            const cartItem = cartData.items[index];

            if (analysis.componentKeys.has(cartItem.key)) {
                continue;
            }

            if (this.getLineProperty(cartItem, '_bundle_token') && !this.getLineProperty(cartItem, '_slot_id')) {
                continue;
            }

            const existingItem = document.querySelector(`.cart-product-item[data-line-id="${CSS.escape(cartItem.key)}"]`);
            if (existingItem) {
                continue;
            }

            const customGrip = this.getLineProperty(cartItem, 'Custom Grip');
            await this.addItemToSidebarCart(
                String(cartItem.variant_id),
                cartItem.quantity,
                customGrip,
                cartItem.handle,
                false,
                cartItem.key
            );

            const addedItem = document.querySelector(`.cart-product-item[data-line-id="${CSS.escape(cartItem.key)}"]`);
            const bundleToken = this.getLineProperty(cartItem, '_bundle_token');
            if (addedItem && bundleToken) {
                addedItem.setAttribute('data-bundle-token', bundleToken);
            }
        }

        this.applyBundleSidebarVisibility(cartData);
        await this.ensureBundleDrawerMarkup(cartData);
    },
    initEventListeners: function() {
      const {htmlEl, cartIcon, cartClose, wrapperOverlay, removeItemBtns, quantityInputs, addGiftBtns, quickAddBtns, customBannerLink } = this;

      if (cartIcon) {
        cartIcon.addEventListener('click', (event) => {
          event.preventDefault();
          if (window.location.href.includes('selkirk.com/cart')) {
            return;
          }
          Utility.hideProgressBarPopup();
          htmlEl.classList.add('cart-show');
        });
      }
      
      if (cartClose) {
        cartClose.addEventListener('click', () => {
          Utility.restoreProgressBarPopup();
          htmlEl.classList.remove('cart-show');

          
        });
      }
      
      if (wrapperOverlay)  {
        wrapperOverlay.addEventListener('click', () => {
          Utility.restoreProgressBarPopup();
          htmlEl.classList.remove('cart-show');
        });
      }
      
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          if (htmlEl.classList.contains('cart-show')) {
            Utility.restoreProgressBarPopup();
            htmlEl.classList.remove('cart-show');
          }
        }
      });
      
      if (removeItemBtns) {
        removeItemBtns.forEach((btn) => {
          const item = btn.closest('.cart-product-item');
          btn.addEventListener('click', () => {
            this.removeFromCart(item);
          });
        });
      }

      if (quantityInputs) {
        quantityInputs.forEach((input) => {
          input.addEventListener('change', () => {

            const item = input.closest('.cart-product-item');
            const itemId = item.dataset.lineId;
            
            this.updateCartLineQuantity(itemId, input.value, item);
          });
        });
      }
      if (addGiftBtns) {
        addGiftBtns.forEach((btn) => {
          btn.addEventListener('click', (event) => {
            this.addToCart(event);
          });
        });
      }
      if (quickAddBtns) {
        quickAddBtns.forEach((btn) => {
          btn.addEventListener('click', (event) => {
            this.addToCart(event);
          });
        });
      }
      if (customBannerLink) {
        customBannerLink.addEventListener('click', (event) => {
          const targetTitle = customBannerLink.getAttribute('data-target-title');

          if (targetTitle) {
            const upsellBlocks = document.querySelectorAll('.upsell-promo-container:not(.hidden-block)');
            let targetBlock = null;

            upsellBlocks.forEach((block) => {
              const blockTitle = block.getAttribute('data-promo-title');
              if (blockTitle === targetTitle) {
                targetBlock = block;
              }
            });

            if (targetBlock) {
              event.preventDefault();
              const cartDrawer = document.getElementById('dropdown-cart');

              if (cartDrawer) {
                const scrollPosition = targetBlock.offsetTop - 20;
                cartDrawer.scrollTo({
                  top: scrollPosition,
                  behavior: 'smooth'
                });
              }
            }
          }
        });
      }
    },

    getCartItems: async function () {
      try {
        // Append a timestamp query parameter to make the URL unique on every call.
        // This acts as a cache busting technique to prevent browsers and CDNs from 
        // returning stale data from GET requests, forcing them to fetch the absolute 
        // latest cart payload directly from the Shopify server.
        const timestamp = new Date().getTime();
        const url = "/cart.js?t=" + timestamp;

        const response = await fetch(url, {
          method: "GET",
          headers: {
            "Cache-Control": "no-cache, no-store, must-revalidate",
            "Pragma": "no-cache",
            "Expires": "0"
          }
        });

        if (!response.ok) {
          throw new Error('Network response was not ok.');
        }

        const cartData = await response.json();

        return cartData;
      } catch (error) {
        console.error('Error getting cart', error);
      }
    },

    removeFromCart: async function (item) {
      const { loadingSpinner } = this;
      loadingSpinner.style.display = 'block';

      const bundleToken = item.dataset.bundleToken;
      if (bundleToken) {
        try {
          const cartData = await this.getCartItems();
          const updates = {};

          cartData.items.forEach((cartItem) => {
            if (this.getLineProperty(cartItem, '_bundle_token') === bundleToken) {
              updates[cartItem.key] = 0;
            }
          });

          if (Object.keys(updates).length > 0) {
            await fetch("/cart/update.js", {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates }),
            });

            Object.keys(updates).forEach((lineKey) => {
              const lineEl = document.querySelector(`.cart-product-item[data-line-id="${CSS.escape(lineKey)}"]`);
              if (lineEl) {
                lineEl.remove();
              }
            });

            document.querySelectorAll(`.cart-product-item[data-bundle-token="${CSS.escape(bundleToken)}"]`).forEach((lineEl) => {
              lineEl.remove();
            });
          }
        } catch (error) {
          console.error('Error removing bundle:', error);
        }

        await this.updateCart();
        loadingSpinner.style.display = 'none';
        return;
      }

      // Extract current data attributes from the DOM element to identify the item
      const variantId = item.dataset.productId;
      const gripValue = item.dataset.customGrip || "none";
      const hasCustomGrip = gripValue !== "none";

      // Locate the upcharge element if a custom grip is applied
      const upchargeEl = document.querySelector(`[data-product-id="${this.UPCHARGE_VARIANT_ID}"]`);
      let upchargeQtyEl = null;
      let currentUpchargeTotal = 0;

      if (upchargeEl) {
        upchargeQtyEl = upchargeEl.querySelector('.item-quantity');
        currentUpchargeTotal = parseInt(upchargeQtyEl.value, 10);
      }

      try {
        // Get the real cart data from Shopify
        const cartData = await this.getCartItems();

        // Filter the backend cart payload to find exact matches for this variant and grip
        const splitLines = cartData.items.filter((cartItem) => {
          if (this.getLineProperty(cartItem, '_bundle_token')) {
            return false;
          }

          if (String(cartItem.variant_id) !== String(variantId)) {
            return false;
          }

          let cartItemGripValue = "none";

          // Shopify AJAX API returns properties as either an array or an object
          // Parse the payload safely to extract the normalized grip string
          if (Array.isArray(cartItem.properties)) {
            const gripProp = cartItem.properties.find((p) => p.name === "Custom Grip" || p[0] === "Custom Grip");
            if (gripProp) {
              const val = gripProp.value || gripProp[1];
              if (val && val.trim() !== "") {
                cartItemGripValue = val.replace(" (BTOG)", "").trim();
              }
            }
          } else if (cartItem.properties && cartItem.properties["Custom Grip"] && cartItem.properties["Custom Grip"].trim() !== "") {
            cartItemGripValue = cartItem.properties["Custom Grip"].replace(" (BTOG)", "").trim();
          }

          // Compare the sanitized backend grip value against the DOM grip value
          if (cartItemGripValue === gripValue) {
            return true;
          }
          return false;
        });

        const updates = {};
        let quantityToRemove = 0;

        // Mark all matching line items for removal
        splitLines.forEach((split) => {
          updates[split.key] = 0;
          quantityToRemove += split.quantity;
        });

        if (Object.keys(updates).length > 0) {
          // Submit the bulk removal request to the Shopify API
          await fetch("/cart/update.js", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });

          // Update the $5 Upcharge item
          if (hasCustomGrip && upchargeEl) {
            const upchargeKey = upchargeEl.dataset.lineId;
            // Subtract the quantity we just deleted from the total upcharges
            const newUpchargeQty = Math.max(0, currentUpchargeTotal - quantityToRemove);

            await fetch("/cart/change.js", {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: upchargeKey, quantity: newUpchargeQty })
            });

            // Update the upcharge look immediately
            if (newUpchargeQty === 0) {
              upchargeEl.remove();
            } else {
              const upchargePriceEl = upchargeEl.querySelector('.price');
              const pricePerItem = parseFloat(upchargePriceEl.dataset.price);
              const totalPrice = pricePerItem * newUpchargeQty;
              upchargePriceEl.textContent = `${CURRENCY_SYM}${Utility.fmtPrice(totalPrice / 100)}`;
              upchargeQtyEl.value = newUpchargeQty;
            }
          }

          if (item) item.remove();
        }

      } catch (error) {
        console.error('Error removing item:', error);
      }

      // Trigger a full cart refresh to reconcile backend state with the UI
      await this.updateCart();
      loadingSpinner.style.display = 'none';
    },

    updateCartLineQuantity: async function (key, quantity, item) {
      const { loadingSpinner } = this;
      loadingSpinner.style.display = 'block';

      // Make sure we have the DOM element to calculate positions
      if (!item && key) {
        item = document.querySelector(`.cart-product-item[data-line-id="${CSS.escape(key)}"]`);
      }

      if (!item) {
        console.error('Item DOM element not found.');
        loadingSpinner.style.display = 'none';
        return;
      }

      if (item.dataset.bundleToken || item.dataset.bundleHeader === 'true') {
        loadingSpinner.style.display = 'none';
        return;
      }

      // Extract current data attributes from the DOM element to identify the item
      const variantId = item.dataset.productId;
      const gripValue = item.dataset.customGrip || "none";
      const hasCustomGrip = gripValue !== "none";
      const oldQuantity = parseInt(item.dataset.quantity, 10) || 0;
      const diff = quantity - oldQuantity;

      // Locate the upcharge element if a custom grip is applied
      const upchargeEl = document.querySelector(`.cart-product-item[data-product-id="${this.UPCHARGE_VARIANT_ID}"]`);
      let upchargeQtyEl = null;
      let upchargeQty = 0;
      let upchargePriceEl = null;

      if (upchargeEl) {
        upchargeQtyEl = upchargeEl.querySelector(".item-quantity");
        upchargeQty = parseInt(upchargeQtyEl.value, 10);
        upchargePriceEl = upchargeEl.querySelector(".price");
      }

      // Enforce maximum and minimum quantity bounds
      if (quantity > 1000) {
        quantity = 1000;
      }

      if (quantity < 0 || isNaN(quantity)) {
        quantity = 0;
      }

      // Delegate to removal logic if quantity drops to zero
      if (Number(quantity) === 0) {
        await this.removeFromCart(item);
        return;
      }

      try {
        // Get real cart data
        const cartData = await this.getCartItems();

        // Filter the backend cart payload to find exact matches for this variant and grip
        const splitLines = cartData.items.filter((cartItem) => {
          if (this.getLineProperty(cartItem, '_bundle_token')) {
            return false;
          }

          if (String(cartItem.variant_id) !== String(variantId)) {
            return false;
          }

          let cartItemGripValue = "none";

          // Shopify AJAX API returns properties as either an array or an object
          // Parse the payload safely to extract the normalized grip string
          if (Array.isArray(cartItem.properties)) {
            const gripProp = cartItem.properties.find((p) => p.name === "Custom Grip" || p[0] === "Custom Grip");
            if (gripProp) {
              const val = gripProp.value || gripProp[1];
              if (val && val.trim() !== "") {
                cartItemGripValue = val.replace(" (BTOG)", "").trim();
              }
            }
          } else if (cartItem.properties && cartItem.properties["Custom Grip"] && cartItem.properties["Custom Grip"].trim() !== "") {
            cartItemGripValue = cartItem.properties["Custom Grip"].replace(" (BTOG)", "").trim();
          }

          // Compare the sanitized backend grip value against the DOM grip value
          if (cartItemGripValue === gripValue) {
            return true;
          }
          return false;
        });

        if (splitLines.length > 0) {
          let remainingDesiredQty = quantity;
          const updates = {};

          // Distribute the requested quantity across all matching backend line items
          splitLines.forEach((split) => {
            if (remainingDesiredQty > 0) {
              const alloc = Math.min(split.quantity, remainingDesiredQty);
              updates[split.key] = alloc;
              remainingDesiredQty -= alloc;
            } else {
              updates[split.key] = 0;
            }
          });

          // Apply any leftover requested quantity to the first matched line item
          if (remainingDesiredQty > 0) {
            updates[splitLines[0].key] += remainingDesiredQty;
          }

          // Submit the bulk update request to the Shopify API
          await fetch("/cart/update.js", {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: updates })
          });

          // Sync Upcharge
          if (hasCustomGrip && diff !== 0 && upchargeEl) {
            const upchargeKey = upchargeEl.dataset.lineId;
            const newUpchargeQty = Math.max(0, upchargeQty + diff);

            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: upchargeKey, quantity: newUpchargeQty })
            });

            // Reconcile the visual upcharge element with the new quantity
            if (newUpchargeQty === 0) {
              upchargeEl.remove();
            } else {
              const pricePerItem = parseFloat(upchargePriceEl.dataset.price);
              const totalPrice = pricePerItem * newUpchargeQty;
              upchargePriceEl.textContent = `${CURRENCY_SYM}${Utility.fmtPrice(totalPrice / 100)}`;
              upchargeQtyEl.value = newUpchargeQty;
            }
          }

          // Update the screen immediately
          item.dataset.quantity = quantity;
        }
      } catch (error) {
        console.error('Error updating quantity:', error);
      }

      // Trigger a full cart refresh to reconcile backend state with the UI
      await this.updateCart();
      loadingSpinner.style.display = 'none';
    },

    updateProgressMeterTiers: function (total) {
      const totalCents = Math.round(parseFloat(total) * 100);
      const DOT_FILL_MS = 420; // animation duration for dot fill

      const bars = document.querySelectorAll(".progress-bar-tiers");
      if (!bars.length) return;

      bars.forEach(function (bar) {
        const ctaEl = bar.querySelector(".progress-bar-tiers__cta");
        //if (ctaEl && !bar.dataset.ctaDefault) bar.dataset.ctaDefault = ctaEl.textContent;

        const progressMessage = bar.querySelector(".free_shipping_message");
        const steps = bar.querySelectorAll(".progress-bar-tiers__step");
        const segBars = bar.querySelectorAll(".progress-bar-tiers__seg-bar");
        if (!progressMessage || !steps.length || !segBars.length) return;

        const tiersCents = (bar.dataset.tiers || "").split(",").map(v => parseInt(v.trim(), 10)).filter(n => !isNaN(n));
        const rewards = (bar.dataset.rewards || "").split(",").map(v => v.trim());
        if (!tiersCents.length) return;

        let unlockedIndex = -1;
        for (let i = 0; i < tiersCents.length; i++) {
          if (totalCents >= tiersCents[i]) unlockedIndex = i; else break;
        }
        const nextIndex = unlockedIndex + 1;

        // newly unlocked steps
        const prevUnlocked = parseInt(bar.dataset.prevUnlocked || "-1", 10);
        if (unlockedIndex > prevUnlocked) {
          for (let j = prevUnlocked + 1; j <= unlockedIndex; j++) {
            const step = steps[j];
            if (step) triggerTierUnlockAnimation(step);
          }
        }
        bar.dataset.prevUnlocked = String(unlockedIndex);

        // compute next dot fractional fill
        let dotFillPct = 0;
        if (nextIndex > 0 && nextIndex < tiersCents.length) {
          const prevCap = tiersCents[nextIndex - 1];
          const nextCap = tiersCents[nextIndex];
          if (nextCap > prevCap && totalCents > prevCap) {
            const within = totalCents - prevCap;
            const span = nextCap - prevCap;
            dotFillPct = (within / span) * 100;
            if (dotFillPct < 0) dotFillPct = 0;
            if (dotFillPct > 100) dotFillPct = 100;
          }
        }

        // update dot states
        steps.forEach(function (step, idx) {
          const dot = step.querySelector(".progress-bar-tiers__dot");
          if (idx <= unlockedIndex) {
            step.classList.add("is-unlocked");
            step.classList.remove("is-filling");
            if (dot) dot.style.removeProperty("--dot-fill");
          } else {
            step.classList.remove("is-unlocked");
            if (idx === nextIndex && dotFillPct > 0) {
              step.classList.add("is-filling");
              animateTierDotFill(dot, dotFillPct, DOT_FILL_MS);
            } else {
              step.classList.remove("is-filling");
              if (dot) dot.style.setProperty("--dot-fill", "0%");
            }
          }
        });

        // fill segments up to the next dot
        segBars.forEach(function (segBar, i) {
          const shouldBeFull = i < nextIndex && i < tiersCents.length - 1;
          segBar.style.transform = shouldBeFull ? "scaleX(1)" : "scaleX(0)";
        });

        // heading + hint handling
        if (nextIndex >= tiersCents.length) {
          // Reached goal text
          //if (ctaEl) ctaEl.innerHTML = "You unlocked all gifts";
          if (progressMessage) progressMessage.textContent = "";
        } else {
          if (ctaEl && bar.dataset.ctaDefault) ctaEl.textContent = bar.dataset.ctaDefault;
          const remaining = Math.max(0, tiersCents[nextIndex] - totalCents);
          if (remaining > 0) {
            const raw = rewards[nextIndex] || "";
            const main = (raw.split(" | ")[0] || "").trim();
            const perk = (main.split(" + ").pop() || main).trim();
            const dollars = Utility.fmtPrice(remaining / 100);
            progressMessage.innerHTML = `Only <strong>${CURRENCY_SYM}${dollars}</strong> away from <strong>${perk}</strong>!`;
          } else {
            progressMessage.textContent = "";
          }
        }
      });
      
      function animateTierDotFill(dot, targetPct, duration) {
        if (!dot) return;
        const style = dot.style;
        const current = getTierDotCurrentFill(style);
        const from = isNaN(current) ? 0 : current;
        const to = Math.max(0, Math.min(100, targetPct));
        if (Math.abs(to - from) < 0.5) {
          style.setProperty("--dot-fill", to.toFixed(2) + "%");
          return;
        }
        const start = performance.now();
        function raf(t) {
          const p = Math.min(1, (t - start) / duration);
          // ease-in-out quad
          const eased = p < 0.5 ? 2 * p * p : -1 + (4 - 2 * p) * p;
          const val = from + (to - from) * eased;
          style.setProperty("--dot-fill", val.toFixed(2) + "%");
          if (p < 1) requestAnimationFrame(raf);
        }
        requestAnimationFrame(raf);
      }
      function getTierDotCurrentFill(style) {
        const v = style.getPropertyValue("--dot-fill");
        if (!v) return NaN;
        const n = parseFloat(v.replace("%", ""));
        return isNaN(n) ? NaN : n;
      }
      function triggerTierUnlockAnimation(step) {
        if (!step) return;
        step.classList.add("just-unlocked");
        setTimeout(function () {
          step.classList.remove("just-unlocked");
        }, 600);
      }
    },


    updateProgressBarMultiplier: function(total) {
      const { multiplierProgressBar, parent } = this;

      const progressMeter = parent.querySelector('.progress-bar-multiplier-meter');
      const progressMessage = parent.querySelector('.progress-bar-multiplier-message');
      const unlockedGift = parent.querySelector('.simple-unlocked-gift');
      const earnedMultiplierDisplay = parent.querySelector('.simple-bonus-multiplier');

      if (!progressMeter || !progressMessage || !unlockedGift) {
        console.error('Progress bar elements not found.');
        return;
      }

      const goalAmount = parseFloat(multiplierProgressBar.dataset.goal);
      const rewardAmount = parseFloat(multiplierProgressBar.dataset.reward);
      let previousMultiplier = parseInt(earnedMultiplierDisplay.textContent) || 0;
      let earnedMultiplier = Math.floor(total / goalAmount);

      let earnedAmount = Math.floor(total / goalAmount) * rewardAmount;
      let remainingAmount = goalAmount - (total % goalAmount);

      if (remainingAmount === goalAmount) {
        remainingAmount = 0;
      }

      let progressPercentage = (total % goalAmount) / goalAmount * 100;
      if (progressPercentage > 100) progressPercentage = 100;

      progressMeter.style.width = `${progressPercentage}%`;

      let formattedEarnedAmount = Utility.fmtPrice(earnedAmount, 0);
      let formattedRemainingAmount = Utility.fmtPrice(remainingAmount, remainingAmount % 1 === 0 ? 0 : 2);

      if (earnedMultiplier > previousMultiplier) {
        earnedMultiplierDisplay.classList.add("pop-bonus"); // Add animation class
        setTimeout(() => {
          earnedMultiplierDisplay.classList.remove("pop-bonus"); // Remove class after animation
        }, 500);
      }

      earnedMultiplierDisplay.textContent = `${earnedMultiplier}x`;

      if (total >= goalAmount) {
        unlockedGift.style.display = "block";
        unlockedGift.innerHTML = `You've earned <strong>${CURRENCY_SYM}${formattedEarnedAmount}</strong> in Selkirk Bonus Bucks!<br> Keep spending to earn more!`;
        progressMessage.style.display = "none";
      } else {
        progressMessage.style.display = "block";
        progressMessage.innerHTML = `Only <strong>${CURRENCY_SYM}${formattedRemainingAmount}</strong> away from your next <strong>${CURRENCY_SYM}${Utility.fmtPrice(rewardAmount, 0)}</strong> in Selkirk Bonus Bucks!`;
        unlockedGift.style.display = "none";
      }
    },

    updateProgressBarFreeShipping: function(total) {
      const { parent } = this;

      const container = parent.querySelector('.free_shipping_progress');
      if (!container) return;

      // show the bar as soon as there's at least one cent in the cart,
      // hide it again if the cart is emptied
      if (total > 0) {
        container.style.display = 'flex'
      } else {
        container.style.display = 'none'
        return
      }
    
      const threshold = parseFloat(container.dataset.threshold);
      this.threshold = threshold;
      const meter = container.querySelector('.progress-meter-free-shipping');
      const remainingP = container.querySelector('.free-ship-msg-remaining');
      const unlockedP = container.querySelector('.free-ship-msg-unlocked');
    
      const percentage = Math.min(total / threshold * 100, 100);
      const remaining = Math.max(threshold - total, 0);
      const isUnlocked = total >= threshold;

      // toggle color
      meter.classList.toggle('filled', isUnlocked)
      meter.style.width = `${percentage}%`

      if (isUnlocked) {
        remainingP.style.display = 'none'
        unlockedP.style.display = 'flex'
      } else {
        remainingP.style.display = 'flex'
        remainingP.textContent = `You’re ${CURRENCY_SYM}${Utility.fmtPrice(remaining)} away from free shipping!`
        unlockedP.style.display  = 'none'
      }
    },

    updateCart: async function () {
      const { noItems, hasItems, cartTemplate, multiplierProgressBar, hasAnyTiersBars, progressFreeShippingBar, upsellContainers, defaultContainer } = this;

      // Fetch the most recent state of the cart from the Shopify API
      const cartData = await this.getCartItems();
      const bundleAnalysis = this.analyzeBundleLines(cartData.items);
      const displayItemCount = Math.max(0, cartData.item_count - bundleAnalysis.componentCount);

      // Update the total item count or reset totals if the cart is empty
      if (cartData.item_count !== 0) {
        this.updateCartCount(displayItemCount);
      } else {
        this.updateCartTotal(0);
        this.updateCartCount(0);
        this.updateShipping(0);
      }

      // Exclude gift cards from progress logic
      const excludedProductIds = ['4178164580406', '7231994069094'];

      const aggregatedItems = {};

      // Parse the cart items and group identical variants (including custom grips) together
      cartData.items.forEach((item) => {
        if (this.getLineProperty(item, '_bundle_token')) {
          return;
        }

        const hasCustomGrip = item.properties && item.properties["Custom Grip"] && item.properties["Custom Grip"].trim() !== "";
        let gripValue = "none";

        if (hasCustomGrip) {
          gripValue = item.properties["Custom Grip"];
        }

        // Generate a unique merge key based on the variant ID and specific grip string
        const mergeKey = `${item.variant_id}-${gripValue}`;

        // Aggregate quantities and prices for items that share the exact same merge key
        if (!aggregatedItems[mergeKey]) {
          aggregatedItems[mergeKey] = { ...item };
          aggregatedItems[mergeKey].original_line_total = item.original_line_price;
          aggregatedItems[mergeKey].final_line_total = item.line_price;
        } else {
          aggregatedItems[mergeKey].quantity += item.quantity;
          aggregatedItems[mergeKey].original_line_total += item.original_line_price;
          aggregatedItems[mergeKey].final_line_total += item.line_price;
        }
      });

      const mergedCartItems = Object.values(aggregatedItems);
      const cartLineEls = document.querySelectorAll(".cart-product-item");

      let totalGiftCards = 0;

      // Calculate total value of excluded gift card products
      cartData.items.forEach((item) => {
        if (excludedProductIds.includes(item.product_id.toString())) {
          totalGiftCards += item.price * item.quantity;
        }
      });

      // Calculate cart total minus gift cards and bundle component line prices
      let total = cartData.total_price - totalGiftCards - bundleAnalysis.componentPriceCents;
      let activeUpsellFound = false;
      const visualDiscounts = {};

      // Process configured upsell blocks to determine which, if any, should be displayed
      if (upsellContainers.length > 0) {
        upsellContainers.forEach((container) => {
          let triggerIdsArray = [];
          if (container.dataset.triggerIds) {
            triggerIdsArray = container.dataset.triggerIds.split(",").filter(Boolean);
          }

          let upsellIdsArray = [];
          if (container.dataset.upsellIds) {
            upsellIdsArray = container.dataset.upsellIds.split(",").filter(Boolean);
          }

          let promoPricesObject = {};
          if (container.dataset.promoPrices) {
            promoPricesObject = JSON.parse(container.dataset.promoPrices);
          }

          // Extract and normalize comma-separated variant options from the data attribute.
          let validTriggerOptions = [];
          if (container.dataset.triggerOptions) {
            const splitOptions = container.dataset.triggerOptions.toLowerCase().split(",");
            validTriggerOptions = splitOptions.map((option) => {
              return option.trim();
            });
            validTriggerOptions = validTriggerOptions.filter(Boolean);
          }

          const triggerAll = container.dataset.triggerAll === "true";
          const unlimitedUpsell = container.dataset.unlimitedUpsell === "true";

          let triggerQty = 0;
          let upsellQty = 0;

          // Tally the total number of qualifying trigger products and active upsell items in the cart
          cartData.items.forEach((item) => {
            const isUpsell = upsellIdsArray.includes(item.product_id.toString());

            if (isUpsell) {
              upsellQty += item.quantity;
            } else if (triggerAll) {
              triggerQty += item.quantity;
            } else if (triggerIdsArray.includes(item.product_id.toString())) {
              let doesOptionMatch = true;

              // If specific trigger options are defined, require at least one variant option to match exactly.
              if (validTriggerOptions.length > 0) {
                doesOptionMatch = false;

                if (item.variant_options) {
                  item.variant_options.forEach((optionValue) => {
                    if (optionValue) {
                      const normalizedOption = optionValue.toLowerCase().trim();
                      if (validTriggerOptions.includes(normalizedOption)) {
                        doesOptionMatch = true;
                      }
                    }
                  });
                }
              }

              // Accumulate quantity for items that satisfy both the product ID and variant option requirements.
              if (doesOptionMatch === true) {
                triggerQty += item.quantity;
              }
            }
          });

          let eligibleDiscountQty = triggerQty;

          // Determine the maximum number of upsell units allowed at the discounted price
          if (unlimitedUpsell) {
            if (triggerQty > 0) {
              eligibleDiscountQty = 99999;
            } else {
              eligibleDiscountQty = 0;
            }
          }

          // Calculate visual discounts needed to reconcile frontend display with backend cart totals
          if (triggerQty > 0) {
            mergedCartItems.forEach((cartItem) => {
              const isUpsell = upsellIdsArray.includes(cartItem.product_id.toString());

              if (isUpsell) {
                if (eligibleDiscountQty > 0) {
                  // Only apply the highest priority discount per line item
                  if (!visualDiscounts[cartItem.key]) {
                    const rawPromoPrice = promoPricesObject[cartItem.product_id];

                    if (rawPromoPrice !== undefined && rawPromoPrice !== null) {
                      const promoPriceNumber = Number(rawPromoPrice);

                      if (Number.isFinite(promoPriceNumber)) {
                        const promoPriceCents = Math.round(promoPriceNumber * 100);
                        // Limit the discount to the maximum eligible quantity
                        const qtyToDiscount = Math.min(cartItem.quantity, eligibleDiscountQty);

                        eligibleDiscountQty -= qtyToDiscount;

                        // Reconcile Shopify automatic discounts with the target UI promo price
                        const shopifyDiscount = cartItem.original_line_total - cartItem.final_line_total;
                        const targetVisualDiscount = (cartItem.original_price - promoPriceCents) * qtyToDiscount;
                        const remainingDiscountNeeded = targetVisualDiscount - shopifyDiscount;

                        if (remainingDiscountNeeded > 0) {
                          visualDiscounts[cartItem.key] = {
                            discountNeeded: remainingDiscountNeeded,
                            promoPrice: promoPriceCents
                          };
                        }
                      }
                    }
                  }
                }
              }
            });
          }

          // Toggle visibility of the specific upsell container based on trigger logic
          if (triggerQty > upsellQty) {
            if (activeUpsellFound === false) {
              container.classList.remove("hidden-block");
              activeUpsellFound = true;
            } else {
              container.classList.add("hidden-block");
            }
          } else if (unlimitedUpsell) {
            if (triggerQty > 0) {
              if (activeUpsellFound === false) {
                container.classList.remove("hidden-block");
                activeUpsellFound = true;
              } else {
                container.classList.add("hidden-block");
              }
            } else {
              container.classList.add("hidden-block");
            }
          } else {
            container.classList.add("hidden-block");
          }
        });
      }

      // Iterate over the live DOM elements to apply computed values and formats
      cartLineEls.forEach((el) => {
        if (el.dataset.bundleHeader === 'true' || el.dataset.bundleToken) {
          return;
        }

        const variantId = el.dataset.productId;
        const hasCustomGrip = el.dataset.customGrip === "true";
        let gripValue = "none";

        // Extract the explicit grip string from the DOM element
        if (hasCustomGrip) {
          const smallOptions = el.querySelectorAll(".option small");
          smallOptions.forEach((smallEl) => {
            if (smallEl.textContent && smallEl.textContent.includes("Custom Grip:")) {
              gripValue = smallEl.textContent.replace("Custom Grip:", "").trim();
            }
          });
        }

        const mergeKey = `${variantId}-${gripValue}`;
        const cartItem = aggregatedItems[mergeKey];

        // Skip updating DOM elements that no longer match the cart data payload
        if (!cartItem) {
          return;
        }

        // Keep DOM key attributes updated to prevent stale data bindings
        el.dataset.lineId = cartItem.key;
        el.dataset.quantity = cartItem.quantity;

        const qtyInput = el.querySelector(".item-quantity");
        if (qtyInput) {
          if (qtyInput.value !== cartItem.quantity.toString()) {
            qtyInput.value = cartItem.quantity;
          }
        }

        const priceWrap = el.querySelector(".cart-collateral");
        const appliedDiscount = visualDiscounts[cartItem.key];

        // Inject the appropriate HTML for normal prices or discounted strikethroughs
        if (appliedDiscount) {
          if (appliedDiscount.discountNeeded > 0) {
            total -= appliedDiscount.discountNeeded;

            if (priceWrap) {
              const displayTotal = cartItem.final_line_total - appliedDiscount.discountNeeded;
              priceWrap.innerHTML = `
                      <span class="compare-price" style="text-decoration: line-through; padding-right: 4px; font-size: 12px;">
                        ${CURRENCY_SYM}${Utility.fmtPrice(cartItem.original_line_total / 100)}
                      </span>
                      <span class="price on-sale" data-price="${appliedDiscount.promoPrice}" data-compare-price="${cartItem.original_price}">
                        ${CURRENCY_SYM}${Utility.fmtPrice(displayTotal / 100)}
                      </span>
                    `;
            }
          }
        } else if (cartItem.original_line_total > cartItem.final_line_total) {
          // Native Shopify discount handling (e.g., automatic discounts)
          if (priceWrap) {
            priceWrap.innerHTML = `
                    <span class="compare-price" style="text-decoration: line-through; padding-right: 4px; font-size: 12px;">
                      ${CURRENCY_SYM}${Utility.fmtPrice(cartItem.original_line_total / 100)}
                    </span>
                    <span class="price on-sale" data-price="${cartItem.final_price}" data-compare-price="${cartItem.original_price}">
                      ${CURRENCY_SYM}${Utility.fmtPrice(cartItem.final_line_total / 100)}
                    </span>
                  `;
          }
        } else {
          // Standard full-price display
          if (priceWrap) {
            priceWrap.innerHTML = `<span class="price" data-price="${cartItem.original_price}">${CURRENCY_SYM}${Utility.fmtPrice(cartItem.final_line_total / 100)}</span>`;
          }
        }
      });

      this.updateCartTotal(Utility.fmtPrice(total / 100));
      this.updateShipping(total);

      // Fire subsequent UI updates dependent on the cart total
      if (hasAnyTiersBars) {
        this.updateProgressMeterTiers((total / 100).toFixed(2));
      }

      if (multiplierProgressBar) {
        this.updateProgressBarMultiplier((total / 100).toFixed(2));
      }

      if (progressFreeShippingBar) {
        this.updateProgressBarFreeShipping((total / 100).toFixed(2));
      }

      // Sidebar-only empty/filled toggles
      if (!cartTemplate) {
        if (cartData.item_count === 0) {
          noItems.classList.remove("hidden-block");
          hasItems.classList.add("hidden-block");
        } else {
          noItems.classList.add("hidden-block");
          hasItems.classList.remove("hidden-block");
        }
      }

      // Toggle default fallback recommendations based on active upsell state
      if (defaultContainer) {
        if (activeUpsellFound) {
          defaultContainer.classList.add("hidden-block");
        } else {
          defaultContainer.classList.remove("hidden-block");
        }
      }

      this.applyBundleSidebarVisibility(cartData);
      await this.ensureBundleDrawerMarkup(cartData);
    },

    
    updateCartTotal: function(total) {
      const {cartTemplate} = this;
      if (cartTemplate) {
         // main cart page
        const priceEls = document.querySelectorAll('.th_cart_total_price');
        priceEls.forEach((el) => {
          el.textContent = `${CURRENCY_SYM}${total}`;
        });
      } else {
        // sidebar  cart
        const priceEl = document.querySelector('.total-section .price-text');
        priceEl.textContent = `${CURRENCY_SYM}${total}`;
      }
    },

    updateShipping: function (total) {
      const { fullPageShippingEl, sideBarShippingEl, popupChatCartConfirmShippingEl } = this;

      // this.threshold comes from the cart progress bar threshold value in the customizer
      const threshold = this.threshold ? this.threshold * 100 : 5500;

      const nextText = total > threshold ? "FREE!" : "Calculated at checkout";

      const shippingEls = [
        fullPageShippingEl,
        sideBarShippingEl,
        popupChatCartConfirmShippingEl
      ].filter(Boolean);

      if (!shippingEls.length) return;

      shippingEls.forEach((shippingEl) => {
        shippingEl.textContent = nextText;
      });
    },

    updateCartCount: function(count) {
      const cartCount = document.querySelectorAll('.cartCount');
      cartCount.forEach((el) => {
        el.textContent = count;
      });
    },

    addItemToSidebarCart: async function (id, quantity, customGrip, handle, display, key) {
      const { noItems, hasItems, promo } = this;

      // Normalize the grip string to match backend formatting and data attributes
      const normalizedGripValue = customGrip ? customGrip.replace(" (BTOG)", "").trim() : "none";
      const existingItem = document.querySelector(`.cart-product-item[data-product-id="${id}"][data-custom-grip="${CSS.escape(normalizedGripValue)}"]`);

      // If exact variant and grip combination exists, increase its quantity instead of adding a new row
      if (existingItem) {
        const qtyInput = existingItem.querySelector(".item-quantity");
        const currentQty = parseInt(qtyInput.value || 0, 10);
        const newTotalQty = currentQty + parseInt(quantity, 10);

        // Update the input value
        qtyInput.value = newTotalQty;

        // Trigger the update function to recalculate prices and totals based on the new quantity
        await this.updateCartLineQuantity(existingItem.dataset.lineId, newTotalQty, existingItem);

        // Ensure the cart is open if requested
        if (display) {
          const html = document.querySelector("html");
          Utility.hideProgressBarPopup();
          html.classList.add("cart-show");
        }
        return;
      }

      // Fetch fresh cart and product data for the new line item
      const cartData = await this.getCartItems();
      const cartItem = cartData.items.find((item) => { return item.key === key; });
      let productData = await Utility.fetchProductDataAjax(handle);

      const variant = productData.variants.find((variant) => { return variant.id == id; });

      const readonlyVariants = ["43392971997286", "42119516553318", "44177423663206"];
      const isReadonly = readonlyVariants.includes(variant.id.toString());

      // Create the new DOM element and assign unique tracking attributes
      const container = document.querySelector(".mini-products-list");
      const item = document.createElement("li");
      item.classList.add("item");
      item.classList.add("cart-product-item");

      // Use unique Line Item Key to prevent duplicate IDs in DOM
      item.id = `cart-item-${key}`;
      item.setAttribute("data-product-id", variant.id);
      item.setAttribute("data-line-id", key);
      item.setAttribute("data-quantity", quantity);
      item.setAttribute("data-custom-grip", normalizedGripValue);

      let imageSrc = cartItem?.image || variant.featured_image?.src || productData.featured_image;

      if (typeof ProductPage !== "undefined" && !cartItem?.image && ProductPage.productDetails?.variantId == variant.id) {
        const activeImg = ProductPage.selected?.querySelector("img");
        imageSrc = activeImg?.src || ProductPage.productDetails.image || imageSrc;
      }

      // Build the internal HTML structure for the new item
      item.innerHTML = `
                  <a href="${productData.url}?variant=${variant.id}" class="product-image">
                  <img src="${imageSrc}" alt="${productData.title} - ${variant.title}">
                  </a>
                  <div class="product-details">
                  <a class="product-title" href="${productData.url}?variant=${variant.id}">
                      <span>
                      ${productData.title}
                      </span>
                  </a>
                  ${!variant.title.includes("Default") ?
          `<div class="option">
                      <small>${variant.title}</small>
                  </div>` : ""}
                  
                  <div class="cart-collateral">
                    ${(
          promo && productData.title.toLowerCase().includes(promo) ?
            `<span class="price on-sale" data-price="${variant.price * this.promoAmount}" data-compare-price="${variant.price}">
                          ${CURRENCY_SYM}${Utility.fmtPrice((variant.price * quantity * this.promoAmount) / 100)}
                        </span>` :
            `<span class="price" data-price="${variant.price}">
                          ${CURRENCY_SYM}${Utility.fmtPrice((variant.price * quantity) / 100)}
                        </span>`
        )}
                  </div>
                  <div class="quantity">
                    ${isReadonly ?
          `<input class="item-quantity item-quantity-new" type="text" value="${quantity}" readonly>` :
          `<input class="item-quantity item-quantity-new" name="quantity" id="updates${variant.id}" data-qtt-id1="quantity${variant.id}" value="${quantity}" type="number">`

        }
                    <span class="error-message-input"></span>
                  </div>
                  </div>
                  <a href="javascript:void(0)" title="Remove This Item" class="btn-remove-new btn-remove">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path fill="#000000" d="M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z"/></svg>
                  </a>
                  `;
      container.prepend(item);

      // Inject custom grip details and manage upcharge line items if a grip is selected
      if (normalizedGripValue !== "none") {
        const variantTitleEl = item.querySelector(".product-details .option");
        const gripDiv = document.createElement("div");
        gripDiv.classList.add("option");
        gripDiv.innerHTML = `<small>Custom Grip: ${normalizedGripValue}</small>`;
        variantTitleEl.insertAdjacentElement("afterend", gripDiv);

        const existingUpchargeEl = container.querySelector(
          `.cart-product-item[data-product-id="${this.UPCHARGE_VARIANT_ID}"]`
        );

        if (existingUpchargeEl) {
          // Update displayed quantity & price visually
          const qtyEl = existingUpchargeEl.querySelector(".item-quantity");
          const priceEl = existingUpchargeEl.querySelector(".price");
          const unitPrice = parseFloat(priceEl.dataset.price);

          const newQty = parseInt(qtyEl.value, 10) + parseInt(quantity, 10);
          qtyEl.value = newQty;
          priceEl.textContent = `${CURRENCY_SYM}${Utility.fmtPrice((unitPrice * newQty) / 100)}`;
        } else {
          // Add a new visible upcharge line
          const upchargeEl = document.createElement("li");
          upchargeEl.classList.add("item", "cart-product-item");
          upchargeEl.setAttribute("data-product-id", this.UPCHARGE_VARIANT_ID);
          upchargeEl.setAttribute("data-line-id", this.UPCHARGE_VARIANT_ID);
          upchargeEl.setAttribute("data-quantity", quantity);

          upchargeEl.innerHTML = `
                    <div class="product-image no-image"></div>
                    <div class="product-details">
                      <span class="product-title">Paddle Customization</span>
                      <div class="cart-collateral">
                        <span class="price" data-price="500">${CURRENCY_SYM}${Utility.fmtPrice(5 * quantity)}</span>
                      </div>
                      <div class="quantity">
                        <input class="item-quantity" type="text" value="${quantity}" readonly>
                      </div>
                    </div>
                  `;

          container.prepend(upchargeEl);
        }
      }

      // attach event listeners to newly created buttons
      const newBtn = container.querySelector('.btn-remove-new');
      newBtn.addEventListener('click', () => {
        this.removeFromCart(item);
      });

      const newQuantity = container.querySelector('.item-quantity-new');
      newQuantity.addEventListener('change', async () => {
        await this.updateCartLineQuantity(key, newQuantity.value, item);
      });

      if (hasItems) {
        hasItems.classList.remove("hidden-block");
      }
      if (noItems) {
        noItems.classList.add("hidden-block");
      }

      if (display) {
        const html = document.querySelector('html');
        Utility.hideProgressBarPopup();
        html.classList.add('cart-show');
      }
    },

    findLineItem: async function (variantId, grip) {
      // Fetch the latest cart state to ensure accurate matching
      const cartData = await this.getCartItems();

      // Normalize the target grip string to match the format stored in Shopify properties
      const targetGrip = grip ? grip.replace(" (BTOG)", "").trim() : "none";

      const item = cartData.items.find((item) => {
        if (this.getLineProperty(item, '_bundle_token')) {
          return false;
        }

        // Filter out items that do not match the target variant ID
        if (item.variant_id.toString() !== variantId.toString()) {
          return false;
        }

        let itemGrip = "none";

        if (item.properties) {
          // Extract the grip property safely.
          if (Array.isArray(item.properties)) {
            const gripProp = item.properties.find((p) => p.name === "Custom Grip" || p[0] === "Custom Grip");
            if (gripProp) {
              const val = gripProp.value || gripProp[1];
              if (val && val.trim() !== "") {
                itemGrip = val.replace(" (BTOG)", "").trim();
              }
            }
          } else if (item.properties["Custom Grip"] && item.properties["Custom Grip"].trim() !== "") {
            itemGrip = item.properties["Custom Grip"].replace(" (BTOG)", "").trim();
          }
        }

        // Return true if the extracted grip matches the normalized target grip
        if (itemGrip === targetGrip) {
          return true;
        }
        return false;
      });

      if (item) {
        return { key: item.key, quantity: item.quantity };
      } else {
        return null;
      }
    },


    // addGiftsToCart: async function (e) {
    //   const addToCartBtn = e.target;
    //   console.log('CART: adding gifts');
    //   console.log('CART: add to cart btn text', addToCartBtn.textContent.trim());
    //   if (addToCartBtn.textContent.trim() == 'Remove') {
    //     console.log('CART: removing');
    //     const products = document.querySelectorAll('.cart-product-item');
    //     products.forEach((product) => {
    //       if (addToCartBtn.dataset.keys.includes(product.dataset.key)) {
    //         this.removeFromCart(product);
    //       }
    //     });
    //     const allButtons = document.querySelectorAll('button[data-ids]');
    //     allButtons.forEach((btn) => {
    //       btn.classList.remove('disabled');
    //       btn.textContent = 'Add to Cart';
    //       btn.disabled = false;
    //     });
    
    //     // Change the clicked button's text to "Remove"
    //     addToCartBtn.dataset.keys = ''; // Store as a string
    //     return;
    //   }
    //   const keys = [];
    //   const idsString = addToCartBtn.dataset.ids; // Get the data-ids value
    //   const handlesString = addToCartBtn.dataset.handles; // Get the data-ids value
    //   const handles = handlesString.split(','); // Parse handles as an array
    //   const tier = addToCartBtn.dataset.tier; // Get the data-tier value
    //   if (!idsString || !tier) return;
    
    //   // Parse IDs, including backup IDs
    //   const items = idsString.split(',').map((idPair, index) => {
    //     const [primaryId, backup] = idPair.split(':backup=');
    //     return {
    //       primaryId: primaryId.trim(),
    //       backupId: backup ? backup.trim() : null,
    //       handle: handles[index].trim(), // Add handle to the object
    //     };
    //   });
        
    //   let allSuccessful = true;
    
    //   // Process each item
    //   for (const item of items) {
    //     let success = false;
    //     let currentId = item.primaryId;
    
    //     // Attempt to add primary or backup ID
    //     while (!success && currentId) {
    //       const formParams = `items[][id]=${currentId}&items[][quantity]=1&items[][properties][_GIFT]=TIER_${tier}`;
    //       try {
    //         const response = await fetch("/cart/add.js", {
    //           method: "POST",
    //           headers: {
    //             "Content-Type": "application/x-www-form-urlencoded",
    //           },
    //           body: formParams,
    //         });
    
    //         if (!response.ok) {
    //           console.error(`Failed to add item with ID: ${currentId}`);
    //           throw new Error(`Item with ID ${currentId} failed.`);
    //         }
    
    //         const data = await response.json();
    //         console.log(`Item with ID ${currentId} added successfully:`, data);
    //         success = true; // Mark as successful
    //         keys.push(data.items[0].key);
    //         console.log('CART: keys', keys);
    //         this.handleAddSuccess(currentId, addToCartBtn.textContent, false, false, e, null, item.handle, 1, null, null, data.items[0].key);
    //       } catch (error) {
    //         console.error("Add to cart error:", error);
    //         // Switch to backup ID if available and not already attempted
    //         if (currentId === item.primaryId && item.backupId) {
    //           currentId = item.backupId;
    //         } else {
    //           // No backup or retry failed, exit loop
    //           currentId = null;
    //         }
    //       }
    //     }
    
    //     if (!success) {
    //       console.error(`Failed to add both primary and backup IDs for item:`, item);
    //       allSuccessful = false;
    //       alert(`Some items could not be added to the cart.`);
    //     }
    //   }
    
    //   // If all items were successfully added, update button styles and text
    //   if (allSuccessful) {
    //     const allButtons = document.querySelectorAll('button[data-ids]');
    //     allButtons.forEach((btn) => {
    //       btn.classList.add('disabled');
    //       btn.textContent = 'Remove Gift to Claim';
    //       btn.disabled = true;
    //     });
    
    //     // Change the clicked button's text to "Remove"
    //     addToCartBtn.textContent = 'Remove';
    //     addToCartBtn.disabled = false;
    //     addToCartBtn.dataset.keys = keys.join(','); // Store as a string
    //   }
    // },
      
    addToCart: async function (e, options) {
      let handle;
      let card = false;
      const ogBtnText = e.target.textContent;
      e.preventDefault();

      const form = e.target.closest('.cart');

      // Provide immediate visual feedback to prevent duplicate submissions
      if (window.innerWidth < 1200) {
        e.target.textContent = 'Adding...';
      } else {
        e.target.textContent = 'Adding to Cart...';
      }
      e.target.disabled = true;

      const modal = e.target.dataset.modal === 'true';
      let id;
      let quantity = 1;
      let formParams;
      let customGrip;
      let productCard;
      let hasCustomGrip = false;

      const context = options && options.context ? options.context : null;
      const shouldOpenSidebarCart = options && options.shouldOpenSidebarCart !== undefined ? options.shouldOpenSidebarCart : (context !== 'popup-chatbot');
      const shouldUpdateSidebarDom = options && options.shouldUpdateSidebarDom !== undefined ? options.shouldUpdateSidebarDom : false;

      if (!form) {
        // For quick add buttons (no form available)
        productCard = e.target.closest('.product-card');
        id = productCard.querySelector('.product-id-input').value;
        quantity = 1; // Default quantity for quick add buttons
        formParams = new URLSearchParams({
          id,
          quantity,
        });
        handle = e.target.dataset.handle;
      } else {
        // Create FormData object from the form
        const formData = new FormData(form);

        // Sanitization Logic: Handle Duplicate Inputs
        // Get ALL inputs with this name
        const rawGripInputs = formData.getAll('properties[Custom Grip]');

        // Find the one that actually has a value (ignores the blank ghost input)
        const normalizedGrip = rawGripInputs.reverse().find(rawInput => {
          if (!rawInput) return false;

          let cleanedInput = rawInput.trim();
          // Remove Zero Width Spaces and other invisible characters
          cleanedInput = cleanedInput.replace(/[\u200B-\u200D\uFEFF]/g, '');

          return cleanedInput.length > 0 && cleanedInput !== 'undefined' && cleanedInput !== 'null';
        }) || '';

        // Rebuild params cleanly
        formParams = new URLSearchParams(formData);

        // DELETE the conflicting property
        formParams.delete('properties[Custom Grip]');

        // Add back ONLY the valid value (if one exists)
        if (normalizedGrip) {
          formParams.set('properties[Custom Grip]', normalizedGrip);
        }

        id = formParams.get('id');
        customGrip = normalizedGrip;
        hasCustomGrip = !!customGrip;
        quantity = parseFloat(formParams.get('quantity'));

        if (form.classList.contains('card-cart')) {
          card = true;
          const quickAddBtn = form.querySelector('.quick-add');
          handle = quickAddBtn.dataset.handle;
        } else {
          handle = e.target.dataset.handle;
        }
      }

      if (e.target.dataset.promo && this.promo) {
        formParams.append('properties[_cartPromo]', e.target.dataset.promo);
      }

      // Determine if the exact variant + properties combination already exists
      const itemInCart = await this.findLineItem(id, customGrip);

      if (itemInCart) {
        if (id.includes('44177423663206')) {
          window.location.href = '/cart';
          return;
        }

        const key = itemInCart.key;
        const oldQuantity = parseFloat(itemInCart.quantity);
        const newQuantity = oldQuantity + quantity;

        try {
          // updateCartLineQuantity handles both the main item and the upcharge sync.
          await this.updateCartLineQuantity(key, newQuantity);

          if (shouldOpenSidebarCart) {
            await this.handleAddSuccess(id, ogBtnText, modal, card, e, newQuantity, handle, quantity, customGrip, key);
          } else if (shouldUpdateSidebarDom) {
            await this.addItemToSidebarCart(id, quantity, customGrip, handle, false, key);
            e.target.textContent = ogBtnText;
            e.target.disabled = false;
          } else {
            e.target.textContent = ogBtnText;
            e.target.disabled = false;
          }

          if (window.PromoModal) {
            window.PromoModal.onAddSuccess({ variantId: id, handle: handle });
          }
        } catch (error) {
          console.error('PDP: error adding to cart', error);
        }
      } else {
        try {
          const bodyString = formParams.toString();

          const response = await fetch("/cart/add.js", {
            method: "POST",
            body: bodyString,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Accept': 'application/json'
            },
          });

          if (!response.ok) throw new Error('Network response was not ok.');

          const responseData = await response.json();

          // Add the customization upcharge variant if grip selected
          if (hasCustomGrip) {
            await fetch("/cart/add.js", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Accept: "application/json",
              },
              body: new URLSearchParams({
                id: this.UPCHARGE_VARIANT_ID,
                quantity: quantity
              }),
            });
          }

          if (shouldOpenSidebarCart) {
            await this.handleAddSuccess(id, ogBtnText, modal, card, e, null, handle, quantity, customGrip, responseData.key);
          } else if (shouldUpdateSidebarDom) {
            await this.addItemToSidebarCart(id, quantity, customGrip, handle, false, responseData.key);
            e.target.textContent = ogBtnText;
            e.target.disabled = false;
          } else {
            e.target.textContent = ogBtnText;
            e.target.disabled = false;
          }

          if (window.PromoModal) {
            window.PromoModal.onAddSuccess({ variantId: id, handle: handle });
          }
        } catch (error) {
          console.error('PDP: error adding to cart', error);
        }
      }

      // Cleanup UI modals after operation resolves
      const giftCardModal = document.querySelector('.send-as-gift-form');
      const modalBg = document.querySelector('.modal-background');

      if (giftCardModal) {
        giftCardModal.style.display = 'none';
        if (modalBg) {
          modalBg.style.display = 'none';
        }
      }

      await this.updateCart();
    },

    handleAddSuccess: async function (id, ogBtnText, modal, card, e, newQuantity, handle, quantity, customGrip, key) {
      const quickView = document.querySelector('#quickview-modal');
      const modalBg = document.querySelector('.modal-background');
      e.target.textContent = ogBtnText;

      // Close quick view and background overlay if action originated from a modal
      if (modal) {
        if (quickView) {
          quickView.style.display = 'none';
        }
        if (modalBg) {
          modalBg.style.display = 'none';
        }
      }

      // If item already existed, update the quantity input visually and slide out the cart
      if (newQuantity) {
        const itemQuantity = document.querySelector(`#updates${id}`);
        if (itemQuantity) {
          itemQuantity.value = newQuantity;
        }
        const html = document.querySelector('html');
        if (html) {
          html.classList.add('cart-show');
        }
      } else {
        // If it is a new line item, build the DOM node and append it to the list
        await this.addItemToSidebarCart(id, quantity, customGrip, handle, true, key);
      }

      e.target.disabled = false;
      await this.updateCart();
    },

    // Bundle cart helpers
    // Used by the bundle builder flow to group, hide, and render merged bundle lines in the cart drawer.

    // Ensures each bundle has a Liquid-rendered header row in the drawer after AJAX cart updates.
    // Re-fetches cart-drawer when a bundle is in the cart but its header row is missing from the DOM.
    ensureBundleDrawerMarkup: async function (cartData) {
        const list = document.querySelector('.mini-products-list');
        if (!list || !cartData || !Array.isArray(cartData.items)) {
            return;
        }

        const analysis = this.analyzeBundleLines(cartData.items);
        let needsRefresh = false;

        for (const [token, group] of analysis.groups.entries()) {
            const existingHeader = list.querySelector(
                `.cart-product-item[data-bundle-token="${CSS.escape(token)}"][data-bundle-header="true"]`
            );

            if (!existingHeader && (group.parent || group.components[0])) {
                needsRefresh = true;
                break;
            }
        }

        if (!needsRefresh) {
            return;
        }

        const root = window.Shopify?.routes?.root || '/';

        try {
            const response = await fetch(`${root}?sections=cart-drawer`);
            if (!response.ok) {
                return;
            }

            const sections = await response.json();
            const sectionHtml = sections['cart-drawer'];
            if (!sectionHtml) {
                return;
            }

            const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
            const newList = doc.querySelector('.mini-products-list');
            if (!newList) {
                return;
            }

            list.innerHTML = newList.innerHTML;
            this.bindCartLineEvents(list);
        } catch (error) {
            console.warn('Cart: could not refresh mini products list', error);
        }
    },

    // Groups cart lines by _bundle_token into parent/component sets and totals hidden component price and count.
    analyzeBundleLines: function (items) {
        const groups = new Map();
        const componentKeys = new Set();
        let componentPriceCents = 0;
        let componentCount = 0;

        if (!Array.isArray(items)) {
            return {
                groups,
                componentKeys,
                componentPriceCents,
                componentCount,
            };
        }

        items.forEach((item) => {
            const token = this.getLineProperty(item, '_bundle_token');
            if (!token) {
                return;
            }

            if (!groups.has(token)) {
                groups.set(token, { parent: null, components: [] });
            }

            const slotId = this.getLineProperty(item, '_slot_id');
            const group = groups.get(token);

            if (slotId) {
                group.components.push(item);
                componentKeys.add(item.key);
                componentPriceCents += item.final_line_price;
                componentCount += item.quantity;
            } else {
                group.parent = item;
            }
        });

        return {
            groups,
            componentKeys,
            componentPriceCents,
            componentCount,
        };
    },

    // Hides raw bundle component rows in the drawer so only the merged bundle header is visible.
    applyBundleSidebarVisibility: function (cartData) {
        const analysis = this.analyzeBundleLines(cartData.items);
        const cartLineEls = document.querySelectorAll('.cart-product-item');

        cartLineEls.forEach((el) => {
            const lineId = el.dataset.lineId;
            if (lineId && analysis.componentKeys.has(lineId)) {
                el.classList.add('bundle-component-hidden');
                el.setAttribute('hidden', 'hidden');
            } else {
                el.classList.remove('bundle-component-hidden');
                el.removeAttribute('hidden');
            }
        });

        return analysis;
    },

    // Re-attaches remove and quantity listeners after the drawer list HTML is replaced.
    bindCartLineEvents: function (root) {
        const scope = root || document;
        const removeBtns = scope.querySelectorAll('.cart-product-item .btn-remove');

        removeBtns.forEach((btn) => {
            if (btn.dataset.cartBound === 'true') {
                return;
            }

            btn.dataset.cartBound = 'true';
            btn.addEventListener('click', () => {
                const item = btn.closest('.cart-product-item');
                this.removeFromCart(item);
            });
        });

        const quantityInputs = scope.querySelectorAll('.cart-product-item .item-quantity');

        quantityInputs.forEach((input) => {
            if (input.dataset.cartBound === 'true') {
                return;
            }

            input.dataset.cartBound = 'true';
            input.addEventListener('change', () => {
                const item = input.closest('.cart-product-item');
                this.updateCartLineQuantity(item.dataset.lineId, input.value, item);
            });
        });
    },
};

window.Jarvis = window.Jarvis || {};
window.Jarvis.Cart = Cart;